<template>
  <article class="article-card" :data-category="article.category" @click="navigateToArticle">
    <img :src="article.img" :alt="article.title" class="article-img">
    <div class="article-content">
      <span :class="['article-category', article.category]">{{ article.categoryText }}</span>
      <h3 class="article-title">{{ article.title }}</h3>
      <p class="article-excerpt">{{ article.excerpt }}</p>
      <div class="article-meta">
        <span class="article-date"><i class="far fa-calendar"></i> {{ article.date }}</span>
        <a href="#" class="read-more" @click.prevent="navigateToArticle">
          Lire l'article <i class="fas fa-arrow-right"></i>
        </a>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  name: 'ArticleCard',
  props: {
    article: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      default: 0
    }
  },
  mounted() {
    this.$el.style.animationDelay = `${this.index * 0.1}s`
  },
  methods: {
    navigateToArticle(e) {
      e.stopPropagation()
      this.$router.push({ name: 'article', params: { id: this.article.id } })
    }
  }
}
</script>

<style scoped>
.article-card {
  background: white;
  border-radius: var(--radius);
  overflow: hidden;
  box-shadow: var(--shadow);
  transition: var(--transition);
  animation: fadeIn 0.8s ease;
  opacity: 0;
  animation-fill-mode: forwards;
  cursor: pointer;
}

.article-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
}

.article-img {
  height: 200px;
  width: 100%;
  object-fit: cover;
  transition: var(--transition);
}

.article-card:hover .article-img {
  transform: scale(1.05);
}

.article-content {
  padding: 25px;
}

.article-category {
  display: inline-block;
  padding: 5px 12px;
  background: var(--primary);
  color: white;
  border-radius: 50px;
  font-size: 0.8rem;
  font-weight: 600;
  margin-bottom: 15px;
}

.article-category.dev { background: var(--success); }
.article-category.tech { background: var(--warning); }
.article-category.ai { background: var(--danger); }
.article-category.web { background: var(--secondary); }

.article-title {
  font-size: 1.4rem;
  margin-bottom: 12px;
  color: var(--dark);
  line-height: 1.4;
}

.article-excerpt {
  color: var(--gray);
  margin-bottom: 20px;
  font-size: 0.95rem;
}

.article-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.9rem;
  color: var(--gray);
}

.article-date {
  display: flex;
  align-items: center;
  gap: 5px;
}

.read-more {
  color: var(--primary);
  text-decoration: none;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 5px;
  transition: var(--transition);
}

.read-more:hover {
  gap: 10px;
}
</style>